<template>
  <CouponSelector
    class="coupon-editor"
    :value="couponId"
    :location="resource.locationId"
    @input="update"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import { CouponSelector } from '@/features/menu'

import { CouponCommands } from '../commands/CouponCommands'

export default {
  name: 'CouponEditor',
  components: { CouponSelector },
  props: {
    /** The ID of the current block */
    id: { type: String, required: true },
  },
  data() {
    return {
      couponId: null,
    }
  },
  computed: {
    ...mapGetters({
      blockById: 'emailBuilder/blockById',
      resource: 'emailBuilder/currentResource',
    }),
    currentBlock() {
      const { id } = this

      return this.blockById(id)
    },
  },
  methods: {
    async update(couponId) {
      this.couponId = couponId
      await CouponCommands.updateBlock({
        targetId: this.id,
        update: { data: { params: { couponId: this.couponId }, type: 'id' } },
      })
    },
  },
}
</script>
